import { TRAVEL_UG_INSURANCE_FORM_SET_VALUE } from '../../../actions/travelUg/quote';
import { quoteFormValidation } from './quote';
import { TRAVEL_INSURANCE_UG_TRAVEL_DETAILS_FORM_SET_VALUE } from '../../../actions/travelUg/travelDetails';
import { travelDetailsValidation } from './travelDetails';
import { TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE } from '../../../actions/travelUg/employeeDetails';
import { employeeDetailsValidation } from './employeeDetails';
import { TRAVEL_UG_NEXT_OF_KIN_FORM_SET_VALUE } from '../../../actions/travelUg/nextOfKin';
import { nextOfKinValidation } from './nextOfKin';
import { TRAVEL_UG_AGENT_MODAL_DETAILS_SET_VALUE } from '../../../actions/travelUg/agentModal';
import { agentModalFormValidation } from './travelAgentModal';
import { PAYMENTS_SET_VALUE } from '../../../actions/travelUg/payments';
import { paymentsFormValidation } from './payments';

export const travelUgInsuranceValidation = (store, next, action) => {
    if (action.type.startsWith(TRAVEL_UG_INSURANCE_FORM_SET_VALUE)) {
        return quoteFormValidation(store, next, action);
    }

    if (action.type.startsWith(TRAVEL_INSURANCE_UG_TRAVEL_DETAILS_FORM_SET_VALUE)) {
        return travelDetailsValidation(store, next, action);
    }

    if (action.type.startsWith(TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE)) {
        return employeeDetailsValidation(store, next, action);
    }

    if (action.type.startsWith(TRAVEL_UG_NEXT_OF_KIN_FORM_SET_VALUE)) {
        return nextOfKinValidation(store, next, action);
    }

    if (action.type.startsWith(TRAVEL_UG_AGENT_MODAL_DETAILS_SET_VALUE)) {
        return agentModalFormValidation(store, next, action);
    }

    if (action.type.startsWith(PAYMENTS_SET_VALUE)) {
        return paymentsFormValidation(store, next, action);
    }

    return null;
};
